import { render } from "./Suggestion.vue?vue&type=template&id=77a60a74&scoped=true&ts=true"
import script from "./Suggestion.vue?vue&type=script&lang=ts"
export * from "./Suggestion.vue?vue&type=script&lang=ts"

import "./Suggestion.vue?vue&type=style&index=0&id=77a60a74&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a60a74"]])

export default __exports__